/* eslint-disable no-useless-escape */
import React, { useState, useEffect } from "react";
import "react-responsive-modal/styles.css";
import { Modal } from "react-responsive-modal";
import { logOut } from '../../_shared/commonFunction'
import InputComponent from "../_common/inputComponent";
import { useTranslation } from "react-i18next";


const EditStockModal = (props) => {
    const { t } = useTranslation();
    const [quantity, setQuantity] = useState("");
    const [quantityErr, setQuantityErr] = useState(false);
    const [notes, setNotes] = useState("");
    const [notesErr, setNotesErr] = useState(false);
    const [storeDropDownList, setStoreDropDownList] = useState(null);
    const [radioVal, setRadioVal] = useState('add')







    const handleSubmit = async (e) => {
        e.preventDefault();

        if(!quantity){
            setQuantityErr(true);
            return
        }
        if(!notes){
            setNotesErr(true);
            return
        }
        const obj ={
            quantity:radioVal==="remove"?'-'+quantity:quantity,
            notes,
        }
        props.closeModal(obj);


    };

    console.log('radioVal', radioVal)

    return (
        <Modal
            open={props.open}
            onClose={() => props.closeModal()}
            center
            classNames={{ modal: "admin-modal" }}
        >
            <div>
                <p className="admin-banner">{t("common.editStock")}</p>
            </div>
            <form onSubmit={handleSubmit} className="form-own px-3">
                <div className="row">
                    <div className="col-12">
                        <div className="form-own-group">
                            <InputComponent
                                placeholder={t("common.quantity")}
                                label={
                                    <>
                                        {t("common.quantity")} <span className="color-red">*</span>
                                    </>
                                }
                                type="number"
                                name="town"
                                theme="white"
                                value={quantity}
                                handleCallback={(val) => {
                                    setQuantity(val);
                                }}
                                maxLength="10"
                            />

                            {!quantity && quantityErr && <div className="error-text">{t("admin.editStockModal.quantityRequired")}</div>}
                        </div>
                        <div className="form-own-group">
                            <InputComponent
                                placeholder={t("common.notes")}
                                label={
                                    <>
                                        {t("common.notes")} <span className="color-red">*</span>
                                    </>
                                }
                                type="text"
                                name="town"
                                theme="white"
                                value={notes}
                                handleCallback={(val) => {
                                    setNotes(val);
                                }}
                                multiline={true}
                                rows={2}
                            />

                            {!notes && notesErr && <div className="error-text">{t("admin.editStockModal.notesRequired")}</div>}
                        </div>
                    </div>

                    <div className="col-12">
                        <div className="radio-wrapper">
                            <div className="radio">
                                <input
                                    id={'add'}
                                    className="hidden radio-label"
                                    type="radio"
                                    value={'add'}
                                    name="stockAction" // Updated name to be the same for both
                                    checked={radioVal === 'add'}
                                    onChange={() => setRadioVal('add')}
                                />
                                <label className="btn-label" htmlFor={'add'}>
                                    <p>{t("admin.editStockModal.addStock")}</p>
                                </label>
                            </div>

                            <div className="radio">
                                <input
                                    id={'remove'}
                                    className="hidden radio-label"
                                    type="radio"
                                    value={'remove'}
                                    name="stockAction" // Updated name to be the same for both
                                    checked={radioVal === 'remove'}
                                    onChange={() => setRadioVal('remove')}
                                />
                                <label className="btn-label" htmlFor={'remove'}>
                                    <p>{t("admin.editStockModal.removeStock")}</p>
                                </label>
                            </div>
                        </div>

                    </div>


                </div>
                <div className="admin-btn">
                    <button
                        onClick={() => props.closeModal()}
                        className="btn secondary-btn mr-2"
                        type="button"
                    >
                        {t("common.back")}
                    </button>
                    <button type="submit" className="btn primary-btn ml-2">
                        {t("common.submit")}
                    </button>
                </div>
            </form>
        </Modal>
    );
};

export default EditStockModal;
